import { useState } from 'react';

import { Button } from '../../../../../../components/buttons/button';
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogTitle,
} from '../../../../../../components/dialog';
import { TextField } from '../../../../../../components/inputs/text-field';
import { type ErrorAny } from '../../../../../../error/utils';
import { tNamespace } from '../../../../../../services/translation';

const t = tNamespace('app.settings.organization.brands');

export function DeleteBrandDialog(props: {
  brandName: string;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onDeleteBrand: () => void;
}) {
  const { brandName, open, onOpenChange, onDeleteBrand } = props;
  const [brandNameToConfirm, setBrandNameToConfirm] = useState('');
  const [error, setError] = useState<ErrorAny>(null);
  const upperCaseBrandName = brandName.toUpperCase();

  function handleDeleteBrand() {
    setError(null);
    if (brandNameToConfirm.toUpperCase() === upperCaseBrandName) {
      void onDeleteBrand();
      return;
    }

    setError('FIELD_INVALID_BRAND_NAME');
  }

  function handleCloseDialog() {
    setBrandNameToConfirm('');
    setError(null);
    void onOpenChange(false);
  }

  return (
    <Dialog open={open} onOpenChange={handleCloseDialog}>
      <DialogContent hasCloseButton aria-describedby={undefined}>
        <DialogTitle>{t('deleteBrandTitle')}</DialogTitle>
        <p className="font-body-2-m mt-1 text-red-500">{t('deleteBrandDescription')}</p>
        <div className="mt-5 flex w-full gap-4">
          <TextField
            placeholder={upperCaseBrandName}
            label={t('writeBrandNameToConfirm', { brandName: upperCaseBrandName })}
            sizeField="lg"
            className="w-full"
            value={brandNameToConfirm}
            onChange={function (e) {
              setBrandNameToConfirm(e.target.value);
              setError(null);
            }}
            error={error}
          />
        </div>
        <DialogFooter isColumn>
          <Button size="xl" variant="destructive" className="w-full" onClick={handleDeleteBrand}>
            {t('deleteBrandAndContent')}
          </Button>
          <Button size="xl" variant="accent" onClick={handleCloseDialog}>
            <p className="whitespace-nowrap">{t('keepBrand')}</p>
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
